import { LazyMotion } from "framer-motion";

const loadDomAnimation = () =>
  import("@/lib/framerLazyDomAnimation").then((mod) => mod.domAnimation);

/**
 * Loads only the `domAnimation` feature set (no layout projection / drag / pan stack).
 * Features load in a separate chunk after mount so the main bundle stays smaller for LCP.
 * Pair with `m` + `AnimatePresence` from `@/lib/framer-motion-lazy-api` via `LazyFramerMotion.jsx`.
 */
export default function FramerLazyMotionRoot({ children }) {
  return (
    <LazyMotion features={loadDomAnimation} strict>
      {children}
    </LazyMotion>
  );
}
